import styled from "styled-components";
import { Button } from "../../../design-system/components/primitives/Button/Button";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin, fontWeights } from "../../../design-system/tokens/typography";
import { borderRadius } from "../../../design-system/tokens/borders";
import { rawColors } from "../../../design-system/tokens/colors";

export const TitleStack = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h2`
  margin: 0;
  ${typographyMixin("heading", "h5")}
  font-weight: ${fontWeights.semibold};
  color: ${rawColors.text.highEmphasis};
`;

export const Subtitle = styled.p`
  margin: 0;
  ${typographyMixin("caption", 4)}
  color: ${rawColors.text.mediumEmphasis};
`;

export const CancelLink = styled.button`
  background: none;
  border: none;
  ${typographyMixin("body", 3)}
  color: ${rawColors.text.mediumEmphasis};
  cursor: pointer;
  padding: ${spacing[2]} ${spacing[3]};

  &:hover {
    color: ${rawColors.text.highEmphasis};
  }
`;

export const FooterRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const PrimaryPillButton = styled(Button)`
  border-radius: ${borderRadius.full};
  background-color: ${rawColors.primary[500]};
  border-color: ${rawColors.primary[500]};
  color: ${rawColors.text.white};

  &:hover:not(:disabled) {
    background-color: ${rawColors.primary[600]};
    border-color: ${rawColors.primary[600]};
  }
`;
